<template>
  <div class="sid-select">
    <SidbearSettingsGroup
      title="Main Text"
      :button-class="buttonClass"
      active
      content-class="border-0"
    >
      <b-form-group v-if="linked && !subjectHide.includes('unlink')">
        <button
          class="flex p-0 text-[11px] hover:bg-gray-100 items-center text-dark border rounded-[4px] w-[114px] h-[30px] justify-content-center gap-[5px] cursor-pointer font-[500] hover:text-[#3D82EA] text-[#7E7E7E]"
          @click="() => unlinkSid()"
        >
          Unlink Styles
          <i class="fa fa-link text-primary" />
        </button>
      </b-form-group>

      <rule-tabs>
        <template slot="Normal">
          <b-form-group
            v-if="!hide.includes('text')"
            label="Text"
          >
            <b-input v-model="section.options.content.button.text" />
          </b-form-group>

          <sid-font
            :sid="`.estage-btn.--${section.sid}--1`"
          />

          <sid-range-slider
            label="Text Size"
            :sid="`.estage-btn.--${section.sid}--1`"
            rule-name="font-size"
          />

          <sid-range-slider
            label="Letter-Spacing"
            :sid="`.estage-btn.--${section.sid}--1`"
            rule-name="letter-spacing"
          />

          <sid-range-slider
            label="Line-Height"
            :sid="`.estage-btn.--${section.sid}--1`"
            rule-name="line-height"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Text Color</label>

              <sid-color
                :sid="`.estage-btn.--${section.sid}--1`"
                rule-name="color"
              />
            </div>
          </b-form-group>

          <sid-align
            :sid="`.estage-btn.--${section.sid}--1 .main-text`"
            rule-name="justify-content"
            label="Text Alignment"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="p-0">Text Decoration</label>

              <sid-font-style
                :sid="`.estage-btn.--${section.sid}--1 .main-text`"
                rule-name="font"
              />
            </div>
          </b-form-group>
        </template>

        <template slot="Hover">
          <sid-range-slider
            label="Text Size"
            :sid="`.estage-btn.--${section.sid}--1`"
            rule-name="font-size"
            presudo=":hover"
          />

          <sid-range-slider
            label="Letter-Spacing"
            :sid="`.estage-btn.--${section.sid}--1`"
            rule-name="letter-spacing"
            presudo=":hover"
          />


          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Text Color</label>

              <sid-color
                :sid="`.estage-btn.--${section.sid}--1`"
                presudo=":hover"
                rule-name="color"
              />
            </div>
          </b-form-group>
        </template>

        <template slot="Focus">
          focus
        </template>
      </rule-tabs>
    </SidbearSettingsGroup>

    <SidbearSettingsGroup 
      title="Subtext"
      :button-class="buttonClass"
    >
      <rule-tabs>
        <template slot="Normal">
          <b-form-group
            v-if="!hide.includes('text')"
            label="Text"
          >
            <b-input v-model="section.options.content.button.subtext" />
          </b-form-group>

          <sid-font
            :sid="`.--${section.sid}--subtext`"
          />

          <sid-range-slider
            label="Text Size"
            :sid="`.--${section.sid}--subtext`"
            rule-name="font-size"
          />

          <sid-range-slider
            label="Letter-Spacing"
            :sid="`.--${section.sid}--subtext`"
            rule-name="letter-spacing"
          />

          <sid-range-slider
            label="Line-Height"
            :sid="`.--${section.sid}--subtext`"
            rule-name="line-height"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Text Color</label>

              <sid-color
                :sid="`.--${section.sid}--subtext`"
                rule-name="color"
              />
            </div>
          </b-form-group>

          <sid-align
            :sid="`.--${section.sid}--subtext`"
            rule-name="justify-content"
            label="Text Alignment"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="p-0">Text Decoration</label>

              <sid-font-style
                :sid="`.--${section.sid}--subtext`"
                rule-name="font"
              />
            </div>
          </b-form-group>
        </template>

        <template slot="Hover">
          <sid-range-slider
            label="Text Size"
            :sid="`.--${section.sid}--1 .--${section.sid}--subtext`"
            rule-name="font-size"
            presudo=":hover"
          />

          <sid-range-slider
            label="Letter-Spacing"
            :sid="`.--${section.sid}--1 .--${section.sid}--subtext`"
            rule-name="letter-spacing"
            presudo=":hover"
          />


          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Text Color</label>

              <sid-color
                :sid="`.--${section.sid}--1 .--${section.sid}--subtext`"
                presudo=":hover"
                rule-name="color"
              />
            </div>
          </b-form-group>
        </template>
      </rule-tabs>
    </SidbearSettingsGroup>

    <SidbearSettingsGroup 
      title="Layout & Style"
      :button-class="buttonClass"
    >
      <rule-tabs>
        <template #Normal>
          <slot name="button-align">
            <sid-align
              v-if="blockDisplay !== 'flex' && blockDisplay !== 'inline-flex'"
              :sid="`.--${section.sid}--2`"
              rule-name="justify-content"
              label="Button Alignment"
            />
          </slot>

          <sid-background
            :sid="`.estage-btn.--${section.sid}--1`"
            default-color="#77abff"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Width Setting</label>

              <sid-select
                v-model="blockDisplay"
                :sid="`.--${section.sid}--1`"
                rule-name="width"
                :searchable="false"
                multiple
                class="w-[138px]"
                var="--width"
                :options="[
                  {
                    label: 'Default',
                    value: 'block',
                    selector: `.--${section.sid}--container`,
                    property: 'width',
                    customProperties: [[`.--${section.sid}--container`, ['display', 'block']], [`.--${section.sid}--container`, ['width', '100%']], [`.--${section.sid}--1`, ['width', '100%']]]
                  },
                  {
                    label: 'Auto',
                    value: 'auto',
                    selector: `.--${section.sid}--container`,
                    property: 'width',
                    customProperties: [[`.--${section.sid}--container`, ['display', 'inline-block']], [`.--${section.sid}--container`, ['width', '100%']], [`.--${section.sid}--1`, ['width', '']]]
                  },
                  {
                    label: 'Inline',
                    value: 'inline-flex',
                    selector: `.--${section.sid}--container`,
                    property: 'display',
                    customProperties: [[`.--${section.sid}--container`, ['display', 'inline-flex']], [`.--${section.sid}--container`, ['width', 'auto']], [`.--${section.sid}--1`, ['width', '']]]
                  }
                ]"
              />
            </div>
          </b-form-group>

          <sid-range-slider
            label="Width"
            :sid="`.--${section.sid}--1`"
            rule-name="width"
            var="--width"
            default-dimension="%"
            :dimensions="['px', '%']"
            measurement="width"
          />

          <sid-range-slider
            label="Height"
            :sid="`.--${section.sid}--1`"
            rule-name="height"
            var="--height"
            default-dimension="px"
            :dimensions="[]"
          />

          <b-form-group>
            <sid-checkbox
              rule-name="--text-wrap"
              :sid="`.--${section.sid}--1 .main-text`"
              :value="''"
              unchecked-value="nowrap"
            >
              Text Wrap
            </sid-checkbox>
          </b-form-group>

          <b-form-group class="mb-0">
            <div class="flex items-center justify-between">
              <label class="pb-0">Z-Index</label>

              <sid-input
                :sid="`.--${section.sid}--1`"
                rule-name="z-index"
                default-dimension=""
                class="!w-[59px]"
              />
            </div>
          </b-form-group>
        </template>

        <template #Hover>
          <sid-background
            :sid="`.estage-btn.--${section.sid}--1`"
            presudo=":hover"
          />
        </template>
      </rule-tabs>
    </SidbearSettingsGroup>

    <SidbearSettingsGroup 
      title="Border & Radius"
      :button-class="buttonClass"
    >
      <rule-tabs>
        <template slot="Normal">
          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Border Type</label>

              <sid-select
                :sid="`.--${section.sid}--1.estage-btn`"
                rule-name="border-style"
                :searchable="false"
                class="w-[118px]"
                :options="[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]"
              />
            </div>
          </b-form-group>

          <b-form-group>
            <sid-linked-group
              :sid="`.--${section.sid}--1.estage-btn`"
              label="Border Width"
              rule-name="border"
              class="!mb-[7px]"
              :angles="[
                {
                  text: '',
                  value: 'top-width'
                },
                {
                  text: '',
                  value: 'right-width'
                },
                {
                  text: '',
                  value: 'bottom-width'
                },
                {
                  text: '',
                  value: 'left-width'
                }
              ]"
            />

            <div class="flex w-full justify-end">
              <sid-color
                :sid="`.--${section.sid}--1.estage-btn`"
                rule-name="border-color"
              />
            </div>
          </b-form-group>

          <sid-linked-group
            label="Radius"
            :sid="`.--${section.sid}--1.estage-btn`"
            rule-name="border"
            class="mb-0"
            :angles="[
              {
                text: 'Top Left',
                value: 'top-left-radius'
              },
              {
                text: 'Top Right',
                value: 'top-right-radius'
              },
              {
                text: 'Bottom Left',
                value: 'bottom-left-radius'
              },
              {
                text: 'Bottom Right',
                value: 'bottom-right-radius'
              }
            ]"
          />
        </template>

        <template slot="Hover">
          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Border Type</label>

              <sid-select
                :sid="`.--${section.sid}--1.estage-btn`"
                rule-name="border-style"
                :searchable="false"
                class="w-[118px]"
                presudo=":hover"
                :options="[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]"
              />
            </div>
          </b-form-group>

          <b-form-group>
            <sid-linked-group
              :sid="`.--${section.sid}--1.estage-btn`"
              label="Border Width"
              rule-name="border"
              class="!mb-[7px]"
              presudo=":hover"
              :angles="[
                {
                  text: '',
                  value: 'top-width'
                },
                {
                  text: '',
                  value: 'right-width'
                },
                {
                  text: '',
                  value: 'bottom-width'
                },
                {
                  text: '',
                  value: 'left-width'
                }
              ]"
            />

            <div class="flex w-full justify-end">
              <sid-color
                :sid="`.--${section.sid}--1.estage-btn`"
                presudo=":hover"
                rule-name="border-color"
              />
            </div>
          </b-form-group>

          <sid-linked-group
            label="Radius"
            :sid="`.--${section.sid}--1.estage-btn`"
            rule-name="border"
            presudo=":hover"
            class="mb-0"
            :angles="[
              {
                text: '',
                value: 'top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius'
              }
            ]"
          />
        </template>
      </rule-tabs>
    </SidbearSettingsGroup>

    <SidbearSettingsGroup
      title="Icon"
      :button-class="buttonClass"
    >
      <rule-tabs>
        <template #Normal>
          <b-form-group>
            <icon-select
              v-model="config.icon.icon"
            />
          </b-form-group>

          <b-form-group>
            <sid-range-slider
              label="Icon Size"
              :sid="`.--${section.sid}--1 .--${section.sid}--3`"
              rule-name="font-size"
            />
          </b-form-group>

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Icon Position</label>

              <b-btn-group>
                <b-btn
                  variant="white"
                  class="w-[33px] h-[29px] flex items-center justify-center p-0"
                  :class="{'!bg-gray-100': iconPosition === 'left'}"
                  @click="() => iconPosition = 'left'"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <rect
                      x="0.475586"
                      y="0.475403"
                      width="14.9508"
                      height="14.9508"
                      fill="url(#pattern0)"
                    />
                    <defs>
                      <pattern
                        id="pattern0"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                      >
                        <use
                          xlink:href="#image0_7663_56750"
                          transform="scale(0.00195312)"
                        />
                      </pattern>
                      <image
                        id="image0_7663_56750"
                        width="512"
                        height="512"
                        xlink:href="data:image/png;base64,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"
                      />
                    </defs>
                  </svg>
                </b-btn>
                <b-btn
                  variant="white"
                  class="w-[33px] h-[29px] flex items-center justify-center p-0"
                  :class="{'!bg-gray-100': iconPosition === 'right'}"
                  @click="() => iconPosition = 'right'"
                >
                  <svg
                    width="15"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <rect
                      x="14.9512"
                      y="15.4262"
                      width="14.9508"
                      height="14.9508"
                      transform="rotate(-180 14.9512 15.4262)"
                      fill="url(#pattern0)"
                    />
                    <defs>
                      <pattern
                        id="pattern0"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                      >
                        <use
                          xlink:href="#image0_7663_56751"
                          transform="scale(0.00195312)"
                        />
                      </pattern>
                      <image
                        id="image0_7663_56751"
                        width="512"
                        height="512"
                        xlink:href="data:image/png;base64,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"
                      />
                    </defs>
                  </svg>
                </b-btn>
              </b-btn-group>
            </div>
          </b-form-group>

          <sid-range-slider
            label="Icon Spacing"
            :sid="`.--${section.sid}--1 .main-text`"
            rule-name="gap"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Icon Color</label>

              <sid-color
                label="Text Color"
                :sid="`.--${section.sid}--1 .--${section.sid}--3`"
                rule-name="color"
              />
            </div>
          </b-form-group>

          <hr>

          <sid-lottie-icon
            :config="config.icon"
            :sid="section.sid"
          />
        </template>

        <template #Hover>
          <b-form-group>
            <sid-range-slider
              label="Icon Size"
              :sid="`.--${section.sid}--1 .--${section.sid}--3`"
              rule-name="font-size"
              presudo=":hover"
            />
          </b-form-group>

          <sid-range-slider
            label="Icon Spacing"
            :sid="`.--${section.sid}--1  .main-text`"
            presudo=":hover"
            rule-name="gap"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Icon Color</label>

              <sid-color
                label="Text Color"
                :sid="`.--${section.sid}--1 .--${section.sid}--3`"
                rule-name="color"
                presudo=":hover"
              />
            </div>
          </b-form-group>
        </template>
      </rule-tabs>
    </SidbearSettingsGroup>

    <slot name="actions">
      <SidbearSettingsGroup
        v-if="!hide.includes('actions') && !subjectHide.includes('actions')"
        title="Click Action"
        :button-class="buttonClass"
      >
        <ButtonAction
          :config="config"
        />
      </SidbearSettingsGroup>
    </slot>

    <SidbearSettingsGroup 
      title="Drop Shadow"
      :button-class="buttonClass"
    >
      <rule-tabs>
        <template #Normal>
          <b-form-group
            label="Shadow Color"
            class="mb-0"
          >
            <sid-box-shadow
              :sid="`.--${section.sid}--1`"
              rule-name="box-shadow"
            />
          </b-form-group>
        </template>

        <template #Hover>
          <b-form-group
            label="Shadow Color"
            class="mb-0"
          >
            <sid-box-shadow
              :sid="`.--${section.sid}--1`"
              presudo=":hover"
              rule-name="box-shadow"
            />
          </b-form-group>
        </template>
      </rule-tabs>
    </SidbearSettingsGroup>

    <SidbearSettingsGroup 
      title="Transform"
      :button-class="buttonClass"
    >
      <rule-tabs>
        <template #Normal>
          <sid-transform
            :sid="`.--${section.sid}--1`"
            rule-name="transform"
            :section="section"
          />
        </template>

        <template #Hover>
          <sid-transform
            :sid="`.--${section.sid}--1`"
            rule-name="transform"
            presudo=":hover"
            :section="section"
          />
        </template>
      </rule-tabs>
    </SidbearSettingsGroup>

    <SidbearSettingsGroup 
      title="Animations"
      :button-class="buttonClass"
    >
      <animations
        :sid="section.uid"
        :animations="section.options.content.button.animations"
        class="mb-4"
      />

      <hover-animations
        v-model="hoverAnimation"
        class="mb-0"
      />

      <sid-range-slider
        label="Animation duration (ms)"
        rule-name="transition-duration"
        :sid="`.estage-btn.--${section.sid}--1`"
        class="mt-4"
        default-dimension="ms"
        :dimensions="['ms']"
        step="100"
        :min="0"
        :max="2500"
      />
    </SidbearSettingsGroup>

    <tooltip-mod
      :config="section"
      component-name="tooltip"
      :button-class="buttonClass"
    />

    <SidbearSettingsGroup
      v-if="!hide.includes('EGT') && !subjectHide.includes('EGT')"
      title="EGT Event Actions"
      :button-class="buttonClass"
    >
      <EstageTracking
        :section="section"
        :events="[
          {
            label: 'On Show',
            value: 'on-show',
            actions: []
          },
          {
            label: 'On Hide',
            value: 'on-hide',
            actions: []
          },
          {
            label: 'On Click',
            value: 'on-click',
            actions: []
          }
        ]"
      />
    </SidbearSettingsGroup>

    <SidbearSettingsGroup
      v-if="gdpr"
      title="GDPR Compliance"
      :button-class="buttonClass"
    >
      <b-form-group label="Text Color">
        <sid-color
          :sid="`.--${section.sid}--container .custom-control-label .custom-control-legend`"
          rule-name="color"
        />
      </b-form-group>

      <sid-range-slider
        :sid="`.--${section.sid}--container .custom-control-label .custom-control-legend`"
        rule-name="font-size"
        label="Font Size"
      />

      <b-form-group>
        <sid-font :sid="`.--${section.sid}--container .custom-control-label`" />
      </b-form-group>

      <sid-align
        :sid="`.--${section.sid}--container .custom-checkbox`"
        rule-name="justify-content"
        label="Text Alignment"
      />
    </SidbearSettingsGroup>

    <slot name="realTimeVisibility">
      <SidbearSettingsGroup
        v-if="!hide.includes('realTimeVisibility') && !subjectHide.includes('realTimeVisibility')"
        title="Real-Time Show/Hide"
        :button-class="buttonClass"
        premium
      >
        <div v-if="!section.options.content.button.fbBtnID">
          <b-btn
            variant="primary"
            @click="initRealTimeVisibility"
          >
            Enable Real-Time Visibility
          </b-btn>
        </div>
        <div v-else>
          <b-form-group>
            <b-checkbox
              v-model="realTimeVisibility"
              switch
              :disabled="realTimeLoading"
              @change="updateRealTimeVisibility"
            >
              {{ realTimeVisibility ? 'Shown' : 'Hidden' }}
              <b-spinner
                v-if="realTimeLoading"
                small
                class="ml-2"
                variant="primary"
              />
            </b-checkbox>
          </b-form-group>
          <delete-confirm
            title="Are you sure?"
            description="The real-time visibility will be disable"
            @confirm="removeRealTimeVisibility"
          >
            <template #activator="{on}">
              <b-link
                class="text-danger text-decoration-none hover:opacity-80"
                v-on="on"
              >
                Disable Real-Time Visibility
              </b-link>
            </template>
          </delete-confirm>
        </div>
      </SidbearSettingsGroup>
    </slot>

    <SidbearSettingsGroup 
      :title="`${groupPrefix} Padding & Margins`" 
      :button-class="buttonClass"
    >
      <sid-linked-group
        label="Padding"
        :sid="`.--${section.sid}--1`"
        rule-name="padding"
        :min="0"
        :angles="[
          {
            text: '',
            value: 'top'
          },
          {
            text: '',
            value: 'right'
          },
          {
            text: '',
            value: 'bottom'
          },
          {
            text: '',
            value: 'left'
          }
        ]"
      />

      <sid-linked-group
        label="Margin"
        :sid="`.--${section.sid}--1`"
        rule-name="margin"
        :min="-2000"
        :max="2000"
        class="mb-0"
        :angles="[
          {
            text: '',
            value: 'top'
          },
          {
            text: '',
            value: 'right'
          },
          {
            text: '',
            value: 'bottom'
          },
          {
            text: '',
            value: 'left'
          }
        ]"
      />
    </SidbearSettingsGroup>

    <slot name="device" />
  </div>
</template>

<script>
/* eslint-disable */
import _ from 'lodash'
import ModMixin from '@builder/components/mixins/ModMixin'
import IconSelect from '../components/IconSelect'
import ButtonAction from '@/components/editor/controls/button-mod/ButtonAction'
import SidRangeSlider from '@/components/editor/components/sid-controls/SidRangeSlider'
import SidColor from '@/components/editor/components/sid-controls/SidColor'
import SidAlign from '@/components/editor/components/sid-controls/SidAlign'
import SidLinkedGroup from '@/components/editor/components/sid-controls/SidLinkedGroup'
import SidLinkedGroupSlider from '@/components/editor/components/sid-controls/SidLinkedGroupSlider'
import SidSelect from '@/components/editor/components/sid-controls/SidSelect'
import SidBackground
  from '@/components/editor/components/sid-controls/sid-control-pressets/background-color/SidBackground'
import SidBoxShadow from '@/components/editor/components/sid-controls/sid-control-pressets/box-shadow/SidBoxShadow'
import RuleTabs from "@/components/editor/components/RuleTabs";
import SidbearSettingsGroup from "@/components/editor/components/SidbearSettingsGroup";
import SidStyles from "@/components/mixins/SidStyles";
import SidTransform from "@/components/editor/components/sid-controls/sid-control-pressets/transform/SidTransform";
import SidInput from "@/components/editor/components/sid-controls/SidInput";
import Animations from "@/components/editor/controls/Animations";
import HoverAnimations from "@/components/editor/controls/HoverAnimations";
import Template from "@/components/builder/elements/private-elements/template-wealth/menu/Template";
import SidFontStyle from "@/components/editor/components/sid-controls/SidFontStyle";
import SidFont from "@/components/editor/components/sid-controls/sid-control-pressets/font/SidFont";
import SidLottieIcon from "@/components/editor/components/sid-controls/sid-control-pressets/SidLottieIcon";
import TooltipMod from "@/components/editor/mods/TooltipMod";
import SidCheckbox from "@/components/editor/components/sid-controls/SidCheckbox";
import {mapActions, mapGetters, mapState} from "vuex";
import EstageTracking from "@/components/editor/controls/es-tracking/EstageTracking.vue";
import SidTransition from "@/components/editor/components/sid-controls/SidTransition.vue";
import {supabase} from "@/supabase";
import DeleteConfirm from "@/components/editor/modals/DeleteConfirm.vue";

export default {
  name: 'ButtonMod',
  components: {
    DeleteConfirm,
    SidTransition,
    EstageTracking,
    SidCheckbox,
    TooltipMod,
    SidLottieIcon,
    SidFont,
    SidFontStyle,
    Template,
    HoverAnimations,
    Animations,
    SidInput,
    SidTransform,
    SidbearSettingsGroup,
    RuleTabs,
    SidBoxShadow,
    SidBackground,
    SidSelect,
    SidLinkedGroupSlider, SidLinkedGroup, SidAlign, SidColor, SidRangeSlider, ButtonAction, IconSelect
  },
  mixins: [ModMixin, SidStyles],
  props: {
    gdpr: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      realTimeLoading: false,
      blockDisplay: null
    }
  },
  methods: {
    ...mapActions({
      createVisibilityElement: 'visibility/createVisibilityElement',
      updateVisibilityElement: 'visibility/updateVisibilityElement',
      deleteVisibilityElement: 'visibility/deleteVisibilityElement'
    }),
    async saveProject () {
      const allPages = this.$store.getters['pages/getPages']
      const pages = JSON.parse(JSON.stringify(allPages))
      const currentPage = this.$store.state.pages.page
      this.$store.commit('projects/SET_PUBLISING', true)
      this.$store.dispatch('projects/publish', {
        all: false,
        pages: [currentPage, ...pages.data.filter(p => p.id !== currentPage.id)].map((page, index) => {
          return {
            id: page.id,
            status: page.page_status,
            updContent: index === 0
          }
        }),
        callback: () => {
          this.$store.commit('projects/SET_PUBLISING', false)
          this.$store.dispatch('pages/loadPages')
        }
      }, {call: true})
          .catch(() => {
            this.$store.commit('projects/SET_PUBLISING', false)
            this.$swal({
              icon: 'error',
              title: 'Server error',
              text: 'Please try again later or let us know about your problem.',
              showConfirmButton: false,
              timer: 3500
            })
          })
    },
    getBlockDisplay () {
      setTimeout(() => {
        const el = document.querySelector(`.--${this.section.sid}--container`)
        this.blockDisplay = window.getComputedStyle(el).display
      }, 100)
    },
    initRealTimeVisibility () {
      this.realTimeLoading = true
      this.createVisibilityElement()
        .then(async (data) => {
          this.$set(this.section.options.content.button, 'fbBtnID', data)
          this.$set(this.section.options.content.button, 'realTimeVisibility', true)
          await this.saveProject()
        })
        .finally(() => {
          this.realTimeLoading = false
        })
    },
    async removeRealTimeVisibility () {
      const button = this.section.options.content.button

      const cleanup = async () => {
        this.$delete(button, 'fbBtnID')
        this.$delete(button, 'realTimeVisibility')
        this.$delete(button, 'point')
        await this.saveProject()
      }

      this.realTimeLoading = true

      try {
        if (button.fbBtnID) {
          await this.deleteVisibilityElement(button.fbBtnID)
        }

        await cleanup()

        this.$swal({
          icon: 'success',
          iconColor: '#4F83E3',
          toast: true,
          position: 'top-right',
          title: 'Real-Time Visibility disabled.',
          showConfirmButton: false,
          timer: 3000
        })
      } finally {
        this.realTimeLoading = false
      }
    },
    updateRealTimeVisibility (val) {
      if (!this.section.options.content.button.fbBtnID) return
      this.realTimeLoading = true
      this.updateVisibilityElement({
        id: this.section.options.content.button.fbBtnID,
        state: val
      })
          .finally(() => {
            this.realTimeLoading = false

            this.$swal({
              icon: 'success',
              iconColor: '#4F83E3',
              toast: true,
              position: 'top-right',
              title: 'State is updated!.',
              showConfirmButton: false,
              timer: 3000
            })
          })
    }
  },
  async mounted () {
    this.getBlockDisplay()
    if (supabase && this.section.options.content.button.fbBtnID) {
      const {data} = await supabase
        .from('public_visibility_elements')
        .select('state')
        .eq('old_id', this.section.options.content.button.fbBtnID.toString())
        .maybeSingle()

      if (data) {
        this.section.options.content.button.realTimeVisibility = data.state
      }
    }
  },
  computed: {
    ...mapGetters('auth', {
      userRole: 'userRole'
    }),
    ...mapState('projects', {
      project: state => state.project
    }),
    iconPosition: {
      get() {
        return _.get(this.section.options.content.button, ['iconPosition', this.resolutioner], _.get(this.section.options.content.button, ['iconPosition', 'lg'], 'right'))
      },
      set(val) {
        this.$set(this.section.options.content.button, 'iconPosition', {..._.set(this.section.options.content.button['iconPosition'] || {}, [this.resolutioner], val)})
      }
    },
    realTimeVisibility: {
      get() {
        if (!this.section.options.content.button.hasOwnProperty('realTimeVisibility')) {
          this.$set(this.section.options.content.button, 'realTimeVisibility', true)
        }

        return this.section.options.content.button.realTimeVisibility
      },
      set(val) {
        this.$set(this.section.options.content.button, 'realTimeVisibility', val)
        this.$set(this.section.options.content.button, 'point', this.project.subdomain)
      }
    },
    hoverAnimation: {
      get() {
        return this.config.hoverAnimation || null
      },
      set(val) {
        this.$set(this.config, 'hoverAnimation', val)
      }
    }
  }
}
</script>
